<template>
    <div class="ku-order">
        <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            offset="10"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div class="van-clearfix">
            <van-col span="12" v-for="(val, index) in list" :key="index">
                <div class="top">
                    <van-image round fit="cover" :src="val.shop.image" cover @click="showGoods(val)"></van-image>
                    <div class="t-r" @click="onShow(val)">
                        <div class="an"></div>
                        <div class="ts" v-show="val.pack === 1 || val.pack === 2">
                            <span>取餐号</span>
                            <label>{{ val.order_no }}</label>
                        </div>
                        <div class="wm" v-show="val.pack === 3">
                            <span>外卖单</span>
                        </div>
                        <div class="bot">{{ val.createtime }}</div>
                    </div>
                </div>
            </van-col>
            </div>
        </van-list>

        <van-popup v-model="show" closeable close-icon="close">
            <div class="order-info">
                <van-row>
                    <van-col class="s1 bor" span="24">
                        <span class="c0">{{ info.order_no }}</span>
                        <span class="c1" v-if="info.pack === 1">堂食</span>
                        <span class="c1" v-if="info.pack === 2">外带</span>
                        <span class="c1" v-if="info.pack === 3">外卖</span>
                    </van-col>
                    <!-- 配送信息 -->
                    <van-col class="s2 bor" span="24" v-show="info.pack === 3">
                        <span>{{ info.address }} {{ info.name }}</span>
                        <span>{{ info.mobile }}</span>
                    </van-col>
                    <!-- 备注 -->
                    <van-col class="s3 bor pd" span="24" v-show="info.remarks !== ''">{{ info.remarks }}</van-col>
                    <!-- 餐品 -->
                    <van-col class="s4 bor" span="24">
                        <van-row class="c1" v-for="(vo, i) in info.goods" :key="i">
                            <van-col class="g1" span="4">{{ vo.num }}</van-col>
                            <van-col class="g2" span="15">{{ vo.goods_name }}</van-col>
                            <van-col class="g3" span="5">{{ vo.price }}元</van-col>
                            <van-col class="g4" span="24" v-for="(ve, ie) in vo.raise" :key="ie">
                                <van-col span="4"></van-col>
                                <van-col span="14">*{{ ve.name }}</van-col>
                            </van-col>
                        </van-row>
                        <van-row class="c1 pdt" v-show="info.packing_num > 0">
                            <van-col class="g1" span="4">{{ info.packing_num }}</van-col>
                            <van-col class="g2" span="15">包装费</van-col>
                            <van-col class="g3" span="5">{{ info.packing_price }}元</van-col>
                        </van-row>
                        <van-row class="c1" v-show="info.tableware_num > 0">
                            <van-col class="g1" span="4">{{ info.tableware_num }}</van-col>
                            <van-col class="g2" span="15">餐具</van-col>
                            <van-col class="g3" span="5">{{ info.tableware_price }}元</van-col>
                        </van-row>
                        <van-row class="c1" v-show="info.pack === 3">
                            <van-col class="g1" span="4"></van-col>
                            <van-col class="g2" span="15">外送费</van-col>
                            <van-col class="g3" span="5">{{ info.delivery_price }}元</van-col>
                        </van-row>
                    </van-col>
                    <!-- 餐品 -->
                    <van-col class="s5 bor" span="24">总计： {{ info.price }}元</van-col>
                    <van-col class="s6 bor" span="24">{{ info.shop.shop_name }} {{ info.shop.address }} <br />{{ info.createtime }}</van-col>
                    <van-col class="s7" span="24">饿的神-更懂餐饮的好系统</van-col>
                </van-row>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Image as VanImage, Button, Col, Row, List, Popup } from 'vant';
    import {getCookie, setCookie} from '@/utils/auth'

    Vue.use(VanImage).use(Button).use(Col).use(Row).use(List).use(Popup);
    export default {
        name: "index",
        data() {
            return {
                show: false,
                info: {
                    shop: {
                        shop_name: ''
                    }
                },

                page: 1,
                limit: 20,
                status: -1,
                list: [],
                loading: false,
                finished: false,
            }
        },
        mounted() {
            this.coType = getCookie('coType');
            this.onLoad()
        },
        methods: {
            onLoad() {
                let that = this
                that.loading = true
                if (that.page <= 1) {
                    that.list = []
                }
                this.$API.orderList({
                    status: that.status,
                    page: that.page,
                    limit: that.limit,
                }).then(res => {
                    return res.data;
                }).then(res => {
                    this.loading = false;

                    let data = res.data
                    that.loading = false;
                    if (parseInt(data.length) >= 1) {
                        data.forEach(function (item) {
                            item.goods.forEach(function (vo) {
                                if (vo.raise) {
                                    let arr = vo.raise.split(',')
                                    let raise = [];
                                    arr.forEach(function (ve, ke) {
                                        let ars = ve.split('‡')
                                        raise[ke] = {
                                            id: ars[0],
                                            name: ars[1],
                                            price: ars[2],
                                        }
                                    });
                                    vo.raise = raise
                                }
                                console.log(vo)
                            })
                            that.list.push(item);
                        })
                    } else {
                        that.finished = true;
                    }
                    that.page = that.page+1
                })
            },
            onClick() {
                this.$router.push({
                    path: '/shop'
                })
            },
            onShow(val) {
                this.info = val
                this.show = true
            },
            showGoods(val) {
                if (val.pack === 3) {
                    setCookie('coType', 2);
                } else {
                    setCookie('coType', 1);
                }
                this.$router.push({
                    path: '/goods',
                    query: {
                        shop_id: val.shop_id
                    }
                })
            }
        },
    }
</script>

<style lang="less" scoped>
.ku-order {
    .order-info {
        width: 600px;
        padding: 20px 30px 50px 30px;
        min-height: 300px;
        .s1 {
            position: relative;
            .c0 {
                font-size: 110px;
                color: #000;
                font-weight: bold;
            }
            .c1 {
                position: absolute;
                right: 10px;
                bottom: 5px;
                font-size: 26px;
            }
            padding: 15px 0;
        }
        .bor {
            border-bottom: 1px dashed #666;
        }
        .pdt {
            padding-top: 20px;
        }
        .pd {
            padding: 20px;
        }
        .s2 {
            padding: 20px;
            span {
                display: block;
                height: 45px;
                line-height: 45px;
                font-size: 28px;
                text-align: left;
            }
        }
        .s3 {

        }
        .s4 {
            padding: 20px 10px;
            .c1 {
                text-align: left;
                font-size: 26px;
                line-height: 40px;
                .g3 {
                    text-align: right;
                }
            }
        }
        .s5 {
            padding: 15px 10px;
            font-size: 28px;
            text-align: right;
        }
        .s6 {
            padding: 15px 0;
            font-size: 28px;
            line-height: 40px;
        }
        .s7 {
            padding: 10px 0;
            font-size: 28px;
        }
    }
    .van-list {
        display: block;
        .van-list__finished-text, .van-list__placeholder {
            display: block;
            width: 100%;
            height: 60px;
            line-height: 60px;
            overflow: hidden;
        }

        .top {
            border-bottom: 1px solid #F0DAB3;
            padding: 10px;
            margin: 2px 3px;
            background: #EAEAEA;
            height: 136px;

            .van-image {
                width: 106px;
                height: 106px;
                padding: 15px 0;
                float: left;
            }

            .t-r {
                width: 240px;
                float: left;

                .an {
                    width: 100px;
                    height: 106px;
                    float: left;
                }

                .ts {
                    width: 140px;
                    height: 106px;
                    float: right;

                    span, label {
                        display: block;
                        color: #e45513;
                        text-align: left;
                        text-indent: 10px;
                    }

                    label {
                        font-size: 65px;
                        font-weight: bold;
                    }
                }

                .wm {
                    width: 140px;
                    height: 106px;
                    float: right;

                    span {
                        line-height: 106px;
                        display: block;
                        color: #e45513;
                        text-align: left;
                        text-indent: 10px;
                        font-size: 40px;
                        font-weight: bold;
                    }
                }

                .bot {
                    width: 240px;
                    line-height: 30px;
                    float: left;
                    text-align: right;
                }
            }
        }
    }
}
</style>
